module.exports = __webpack_public_path__ + "static/media/cat-and-dog.36c54a76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat-and-dog.jpg
// module id = 288
// module chunks = 0